import { mapState } from "vuex";

export default {
  computed: {
    ...mapState([
      "search_link",
      "types",
      "classifications",
      "targets",
      "languages",
      "fluencies"
    ])
  },
  data() {
    return {
    };
  },

  mounted() {
    
  }
}